import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary'

import { ddLogger } from '@b-stock/fe-core/bstock-react'

const logError = (error: unknown, info: React.ErrorInfo) => {
  ddLogger.error(
    'Caught error at react error boundary',
    { info },
    error instanceof Error
      ? error
      : new Error('Error not an instance of Error', { cause: error })
  )
}

const ComponentErrorBoundary = ({
  children,
  onError,
}: {
  children: React.ReactNode
  onError?: (error: unknown, info: React.ErrorInfo) => void
}) => {
  return (
    <ReactErrorBoundary
      fallbackRender={() => null}
      onError={onError || logError}
    >
      {children}
    </ReactErrorBoundary>
  )
}

export default ComponentErrorBoundary
